<template> <!-- Stats -->
    <div class="stats-section">
        <div class="stat-item">
            <span class="mdi mdi-eye-outline mx-1"></span>
            <span class="stat-value">{{ vues || 0 }}</span>
        </div>
        <div class="stat-item">
            <span class="mdi mdi-heart mx-1"></span>
            <span class="stat-value">{{ favorites || 0 }}</span>
        </div>
        <div class="stat-item" >
            <span v-if="sales_type === 'auction'" class="mdi mdi-gavel mx-1"></span>
            <span v-if="sales_type === 'auction'" class="stat-value">{{ bids || 0 }}</span>
        </div>
    </div>
</template>


<script>

export default {
    name: "StatsComp",
    props: {
        sales_type: { type: String, default: '' },
        vues: { type: Number, default: 0 },
        favorites: { type: Number, default: 0 },
        bids: { type: Number, default: 0 },
    },
    data() {
        return {
        };
    },
};
</script>
<style scoped>
/* ======= STATS SECTION ======= */
.mdi {
    font-size: 16px;
}

.stats-section {
    width: 400px;
    display: flex;
    justify-content: space-around;
    padding: 2px;
    background: var(--light);
    border-radius: 8px;
    border: 1px solid var(--light);
    margin-top: .75rem;
}

.stat-item {
    width: 150px;
    text-align: center;
    display: flex;
    justify-content: center;
}


.stat-value {
    display: block;
    font-size: 16px;
    font-weight: 700;
    color: var(--color-3);
    display: inline;
}

.stat-label {
    display: block;
    font-size: 12px;
    color: var(--color-6);
    margin-top: 3px;
    display: inline;
}

@media (max-width: 576px) {
    .stats-section {
        width: 100%;
    }

    .stat-item {
        display: flex;
        align-items: center;
    }

    .stat-label::before {
        content: " ";
    }
}
</style>